import { ClientListsManager } from '../components/ClientListsManager';
import { useSubscriberListsQuery } from '../hooks/useSubscriberQueries';

/** Every WhatsApp list, by owner: the research desk's topic lists and each RM's client books, with who is on them. */
export function SubscribersPage() {
  const lists = useSubscriberListsQuery();
  return (
    <ClientListsManager
      title="WhatsApp subscribers"
      description="Lists grouped by owner. Only opted-in numbers receive messages."
      lists={lists}
    />
  );
}
